import { FontAwesome5, FontAwesome6 } from "@expo/vector-icons";
import React, { useState, useEffect } from "react";
import {
  Image,
  ScrollView,
  Text,
  View,
  TouchableOpacity,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  BackButton,
  BottomModal,
  Header,
  Row,
  GradientHeader,
  StatusCard,
  Modal,
  Card,
  ModalButtons,
  VerificationModal,
} from "../../../components/all";
import professions, {
  isAssistant,
  isNurses,
} from "../../../constants/lov/professions";
import { getAdministrativeDivisionLabel, getCountryData } from "../../../constants/countries";
import {
  getUser,
  getProfile,
  getClinics,
  deleteUser,
  getOverview,
} from "../../../services/profile";
import * as WebBrowser from "expo-web-browser";
import { setFields, addFields } from "../../../reducers/profile/profile";
import queryClient from "../../../utils/queryClient";
import ContentLoader, { Rect, Circle } from "react-content-loader/native";
import { normalize } from "../../../utils/normalize";
import { getApplications } from "../../../services/job";
import { extractProfessionTitleAndSubtitle } from "../../../utils/professionUtils";
import { PLACEHOLDER_PROFILE_URL } from "../../../constants/placeholderImage";
export default function App(props) {
  const fromDoctorCard = props.route.params?.fromDoctorCard;
  const doctorCardData = props.route.params?.data;

  const profileEditSuccess = props.route.params?.profileEditSuccess;
  const clinicEditSuccess = props.route.params?.clinicEditSuccess;

  const { fields } = useSelector((state) => state.profile);
  const { isDoctor: checkDoctor, slug, country } = useSelector((state) => state.user);
  let isDoctor = fromDoctorCard ? true : checkDoctor;
  const dispatch = useDispatch();
  const safeInsets = useSafeAreaInsets();
  const [modalVisible, setModalVisible] = useState(false);
  const [verifiedModalVisible, setVerifiedModalVisible] = useState(false);
  const [clinicData, setClinicData] = useState([]);
  const [verifyModalVisible, setVerifyModalVisible] = useState(false);
  const [profession, setProfession] = useState("");

  // Get the appropriate administrative division label for the country
  const divisionLabel = getAdministrativeDivisionLabel(country);

  // Helper functions for country-specific medical license names
  const getMedicalLicenseName = (countryCode) => {
    const names = {
      'MY': 'MMC',  // Malaysian Medical Council
      'SG': 'SMC',  // Singapore Medical Council
      'PH': 'PRC',  // Philippine Regulation Commission
      'ID': 'STR'   // Surat Tanda Registrasi (Indonesia)
    };
    return names[countryCode] || 'Medical Registration';
  };

  const getPracticeLicenseName = (countryCode) => {
    const names = {
      'MY': 'APC',     // Annual Practicing Certificate
      'SG': 'PC',      // Practicing Certificate
      'PH': 'PRC-ID',  // PRC ID number
      'ID': 'SIP'      // Surat Izin Praktik
    };
    return names[countryCode] || 'Practice License';
  };

  const getIdDocumentLabel = (countryCode) => {
    const labels = {
      'MY': 'IC Number',
      'SG': 'NRIC Number',
      'PH': 'Valid ID',
      'ID': 'KTP Number'
    };
    return labels[countryCode] || 'National ID Number';
  };

  const getBusinessRegistrationLabel = (countryCode) => {
    const labels = {
      'MY': 'Business Registration No.',
      'SG': 'Unique Entity No.',
      'PH': 'Business Registration No.',
      'ID': 'Business Identification No.'
    };
    return labels[countryCode] || 'Business Registration No.';
  };

  const {
    data: overviewQuery,
    refetch: overviewRefetch,
    isLoading: overviewLoading,
  } = useQuery("overview", getOverview);
  let overviewInfo = overviewQuery?.data?.data;
  const {
    data: jobsQuery,
    refetch: jobRefetch,
    isLoading: jobLoading,
    isFetched,
  } = useQuery("applications", getApplications);
  const {
    data: profileQuery,
    refetch: profileRefetch,
    isLoading: profileLoading,
  } = useQuery(
    "profile",
    () => (!fromDoctorCard ? getProfile() : getUser(doctorCardData?.slug)),
    {}
  );

  let profileData = profileQuery?.data?.data;
  const {
    data: userQuery,
    refetch: userRefetch,
    isLoading: userLoading,
  } = useQuery("doctorProfile", () => getUser(doctorCardData?.slug), {
    enabled: !!fromDoctorCard,
  });

  const {
    data: clinicsQuery,
    refetch: clinicsRefetch,
    isLoading: clinicLoading,
  } = useQuery("clinics", getClinics, {
    enabled: !isDoctor,
  });
  const facilityTypeName = (() => {
    console.log("clinicData", profileData);
    const facInfo = profileData?.fac;
    if (!facInfo) {
      return clinicData?.type;
    }

    const countryFieldMap = {
      MY: "name_malaysia",
      SG: "name_singapore",
      PH: "name_philippines",
      ID: "name_indonesia",
    };

    const localeKey = countryFieldMap[country?.toUpperCase?.()] || countryFieldMap.MY;
    return (
      facInfo?.[localeKey] ??
      facInfo?.name_malaysia ??
      facInfo?.name_singapore ??
      clinicData?.type ??
      ""
    );
  })();

  const onDeleteUser = useMutation(deleteUser, {
    onError: (error) => {
      alert("Oops! " + error.response.data.message);
    },
    onSuccess: (res) => {
      props.navigation.replace("AuthScreen");
    },
  });

  useEffect(() => {
    if (profileQuery?.data) {
      dispatch(addFields(profileQuery.data.data));
      getProfession(profileQuery.data.data);
    }
  }, [profileQuery]);

  useEffect(() => {
    if (userQuery?.data) {
      dispatch(addFields(userQuery.data.data));
    }
  }, [userQuery]);

  useEffect(() => {
    if (clinicsQuery?.data) {
      let clinicFields = clinicsQuery.data.data;
      setClinicData(clinicFields[0]);
      let { profile_image, name, phone_number, ...fieldsWithoutImage } =
        clinicFields[0];
      console.log("check clinic image", profile_image);
      dispatch(
        addFields({
          ...fieldsWithoutImage,
          clinic_profile_image: profile_image,
          clinic_phone_number: phone_number,
          clinic_name: name,
        })
      );
    }
  }, [clinicsQuery]);

  useEffect(() => {
    if (clinicEditSuccess) {
      clinicsRefetch();
      overviewRefetch();
    }
  }, [clinicEditSuccess]);

  useEffect(() => {
    if (profileEditSuccess) {
      profileRefetch();
      overviewRefetch();
      !isDoctor && clinicsRefetch();
    }
  }, [profileEditSuccess]);
  const convertPhone = (phone) => {
    if (phone) {
      let phoneArray = phone.split("");
      phoneArray.splice(3, 0, "-");
      phoneArray.splice(7, 0, "");
      return phoneArray.join("");
    }
    return "";
  };
  const getProfession = (data) => {
    let id = data?.expertise;
    let prof = professions;
    // if(id > 5) prof = prof.find((item) => item.id === 5).types;
    let p = prof.find((item) => item.id === id);
    setProfession(p?.name);
  };
  useEffect(
    () =>
      props.navigation.addListener("beforeRemove", (e) => {
        // Prevent default behavior of leaving the screen (if needed)
        queryClient.removeQueries("doctorProfile");
        queryClient.removeQueries("profile");
        dispatch(setFields({}));
      }),
    [props.navigation]
  );
  const titleValue = (title, value) => {
    return (
      <>
        <Text
          style={{
            fontSize: normalize(12),
            fontWeight: "bold",
            marginRight: 12,
            marginBottom: 4,
            marginTop: 20,
          }}
        >
          {title}{" "}
          <Text
            style={{
              color: "red",
            }}
          >
            {value ? "" : "*"}
          </Text>
        </Text>

        <Text>{value ? value : "-"}</Text>
      </>
    );
  };
  const editButton = (title, navigateTo, params) => {
    return (
      <TouchableOpacity
        onPress={() => {
          props.navigation.navigate(navigateTo, params);
        }}
      >
        <View style={styles.editButton}>
          <Row style={{ justifyContent: "center" }}>
            <Text
              style={{
                fontSize: normalize(14),
                color: "rgba(0,0,0,0.4)",
              }}
            >
              {title}
            </Text>
          </Row>
        </View>
      </TouchableOpacity>
    );
  };
  const renderTitle = (title, icon) => {
    return (
      <View style={{ marginTop: 20 }}>
        <Row centered>
          <FontAwesome5 name={icon} color="black" size={16} />
          <Text style={styles.sectionTitle}>{title}</Text>
        </Row>
      </View>
    );
  };
  const checkPendingJobs = () => {
    console.log("check jobs", jobsQuery.data.data);
    let noPendingJobs = true;

    if (jobsQuery.data.data) {
      jobsQuery.data.data.map((job) => {
        if ([0, 1, 2, 3].includes(job.job_application_status_code)) {
          noPendingJobs = false;
        }
      });
    }
    return noPendingJobs;
  };
  const onPressDelete = () => {
    const isDeletable = checkPendingJobs();
    if (isDeletable) {
      Alert.alert(
        "Are you sure?",
        `Your account will be deleted and you will not be able to undo this action.`,
        [
          {
            text: "Cancel",
            style: "cancel",
          },
          {
            text: "Confirm",
            style: "destructive",
            onPress: () => {
              onDeleteUser.mutate(slug);
            },
          },
        ]
      );
    } else {
      Alert.alert(
        "Oops!",
        `You have pending jobs. Please complete or cancel them before deleting your account.`,
        [
          {
            text: "Cancel",
            style: "cancel",
          },
          {
            text: "Confirm",
          },
        ]
      );
    }
  };

  return (
    <>
      <GradientHeader />
      <ScrollView
        contentContainerStyle={{
          backgroundColor: "rgba(0,0,0,0)",
          width:
            Dimensions.get("window").width > 780
              ? 780
              : Dimensions.get("window").width,
          alignSelf: "center",
        }}
        showsVerticalScrollIndicator={false}
      >
        {fromDoctorCard ? (
          <View style={{ marginTop: Platform.OS === "ios" ? -40 : 0 }}>
            <BackButton color="white" isClose />
          </View>
        ) : (
          <View
            style={{
              width: "100%",
              alignItems: "flex-end",
              paddingTop: safeInsets.top,
              paddingRight: 20,
            }}
          >
            <View style={{ position: "absolute", left: 0 }}>
              <BackButton color="white" />
            </View>
            <View style={{ margin: 20 }} />
          </View>
        )}
        <Header
          profileLoading={profileLoading || userLoading}
          from={"profile"}
          first_name={profileData?.first_name}
          last_name={profileData?.last_name}
          profile_image={
            isDoctor ? profileData?.profile_image : fields?.clinic_profile_image
          }
          data={{ ...profileData, ...overviewInfo }}
          fromDoctorCard={fromDoctorCard}
          subtitle={clinicData?.department}
          showVerifiedModal={(bool) => {
            setVerifiedModalVisible(bool);
          }}
          onPressVerify={() => {
            setVerifyModalVisible(true);
          }}
        />
        {/* Reports */}

        <View
          style={{
            marginTop: Platform.OS === "web" ? 120 : 0,

            paddingTop: Platform.OS === "web" ? 110 : 14,

            backgroundColor: "white",
            padding: 14,
            paddingHorizontal: 24,
            minHeight: "100%",

            borderTopLeftRadius: Platform.OS === "web" ? 32 : 0,
            borderTopRightRadius: Platform.OS === "web" ? 32 : 0,
          }}
        >
          {fromDoctorCard && typeof profileData?.completed_jobs === "number" ? (
            <>
              {/* <View style={{ flexDirection: "row", marginLeft: -30 }}>
                <Card
                  onPress={() => setVerifiedModalVisible(true)}
                  style={{
                    width:
                      Dimensions.get("window").width > 780
                        ? 500
                        : Dimensions.get("window").width / 1.6,
                    alignSelf: "center",
                    marginRight: 4,
                  }}
                >
                  <View style={{ padding: 20 }}>
                    <Row centered>
                      <Image
                        source={require("../../../assets/images/check.png")}
                        style={{ height: 14, width: 14 }}
                      />
                      <Text
                        style={{
                          paddingLeft: 8,
                          fontSize: normalize(16),
                          fontWeight: "bold",
                        }}
                      >
                        Verified
                      </Text>
                    </Row>
                    <Text style={{ fontSize: normalize(14), marginTop: 10 }}>
                      {`${profileData.first_name} ${profileData.last_name[0]}.`}{" "}
                      account has been verified by the Supermedic team.
                    </Text>
                  </View>
                </Card>
                <Card
                  style={{
                    width:
                      Dimensions.get("window").width > 780
                        ? 220
                        : Dimensions.get("window").width / 3.5,
                    marginHorizontal: 8,
                    alignItems: "center",
                  }}
                  onPress={() => {
                    Linking.openURL(`tel:${profileData?.phone_number}`);
                  }}
                >
                  <View style={{ marginTop: 12 }}>
                    <StatusCard
                      noHr
                      icon={<FontAwesome5 name="phone" />}
                      smallValue
                      data={{
                        title: `Contact\nInformation`,
                        value: convertPhone(profileData?.phone_number) + "\n",
                      }}
                    />
                  </View>
                </Card>
              </View> */}
              <Row style={{ marginTop: 0, justifyContent: "center" }}>
                <Card
                  style={{
                    width:
                      Dimensions.get("window").width > 780
                        ? 220
                        : Dimensions.get("window").width / 3.5,
                    marginHorizontal: 8,
                    alignItems: "center",
                  }}
                >
                  <View style={{ marginTop: 12 }}>
                    <StatusCard
                      icon={<FontAwesome5 name="clipboard-check" />}
                      data={{
                        title: `Completed\nJobs`,
                        value: profileData?.completed_jobs || 0,
                      }}
                    />
                  </View>
                </Card>
                <Card
                  style={{
                    width:
                      Dimensions.get("window").width > 780
                        ? 220
                        : Dimensions.get("window").width / 3.5,
                    marginHorizontal: 8,
                    alignItems: "center",
                  }}
                >
                  <View style={{ marginTop: 12 }}>
                    <StatusCard
                      noHr
                      icon={<FontAwesome5 name="clock" />}
                      data={{
                        title: `Hours\nWorked`,
                        value: profileData?.hours_worked?.toFixed() || 0,
                      }}
                    />
                  </View>
                </Card>

                <Card
                  style={{
                    width:
                      Dimensions.get("window").width > 780
                        ? 220
                        : Dimensions.get("window").width / 3.5,
                    marginHorizontal: 8,
                    alignItems: "center",
                  }}
                  onPress={() => {
                    props.navigation.navigate("RatingScreen", {
                      profileImg: profileData?.profile_image,
                    });
                  }}
                >
                  <View style={{ marginTop: 12 }}>
                    <StatusCard
                      noHr
                      icon={<FontAwesome5 name="trophy" />}
                      data={{
                        title: `Current\nRating`,
                        value: profileData?.average_rating
                          ? profileData.average_rating
                          : "n/a",
                      }}
                    />
                  </View>
                </Card>
              </Row>
            </>
          ) : null}
          {isDoctor ? (
            <>
              {renderTitle("Personal Information", "user")}
              {profileLoading ? (
                <View style={{ marginTop: 20 }}>
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={150}
                    viewBox="0 0 400 150"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                  >
                    <Circle cx="10" cy="20" r="8" />
                    <Rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                    <Circle cx="10" cy="50" r="8" />
                    <Rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                  </ContentLoader>
                </View>
              ) : (
                <>
                  <View style={{ margin: 8 }}>
                    {titleValue("About", profileData?.about)}
                    {titleValue("Phone", profileData?.phone_number)}
                    {titleValue("Email", profileData?.email)}
                    {titleValue(getIdDocumentLabel(country), profileData?.nric_passport_number)}
                    {titleValue(
                      "Emergency Name",
                      profileData?.emergency_name
                    )}
                    {titleValue(
                      "Emergency Mobile No.",
                      profileData?.emergency_number
                    )}
                  </View>
                  {fromDoctorCard
                    ? null
                    : editButton(
                      "Edit Personal Information",
                      "EditProfileScreen"
                    )}
                  <View style={{ margin: 10 }} />
                </>
              )}
            </>
          ) : null}

          {/* Personal Address Section for Doctors */}
          {isDoctor ? (
            <>
              <View style={{ margin: 10 }} />
              {renderTitle("Personal Address", "map-marker-alt")}
              {profileLoading ? (
                <View style={{ marginTop: 20 }}>
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={100}
                    viewBox="0 0 400 100"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                  >
                    <Circle cx="10" cy="20" r="8" />
                    <Rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                    <Circle cx="10" cy="50" r="8" />
                    <Rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                  </ContentLoader>
                </View>
              ) : (
                <>
                  <View style={{ margin: 8 }}>
                    {titleValue("Address", profileData?.address)}
                    {titleValue("City", profileData?.city)}
                    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                      <View style={{ flex: 1 }}>
                        {titleValue("Postcode", profileData?.postcode)}
                      </View>
                      <View style={{ flex: 1 }}>
                        {titleValue(divisionLabel, profileData?.state)}
                      </View>
                    </View>
                  </View>
                  {fromDoctorCard
                    ? null
                    : editButton(
                      "Edit Address",
                      "EditProfileScreen",
                      { isEditAddress: true }
                    )}
                </>
              )}
            </>
          ) : null}

          {isDoctor ? (
            <>
              <View style={{ margin: 10 }} />
              {/* Professional Specialization Section */}
              {renderTitle("Profession", "briefcase-medical")}
              {profileLoading ? (
                <View style={{ marginTop: 20 }}>
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={100}
                    viewBox="0 0 400 100"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                  >
                    <Circle cx="10" cy="20" r="8" />
                    <Rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                    <Circle cx="10" cy="50" r="8" />
                    <Rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                  </ContentLoader>
                </View>
              ) : (
                <>
                  <View style={{ margin: 8 }}>
                    {profileData?.professions && profileData.professions.length > 0 ? (() => {
                      // Get country-specific profession names for all professions
                      const getCountrySpecificProfession = (professionData) => {
                        const professionType = professionData.profession_type;

                        switch (country) {
                          case 'ID':
                            return {
                              profession: professionData.indonesia_name,
                              type: professionType?.malay_name, // Indonesia uses malay_name for type
                              countryLabel: 'Indonesia',
                              original: professionData
                            };
                          case 'SG':
                            return {
                              profession: professionData.singapore_name,
                              type: professionType?.english_name,
                              countryLabel: 'Singapore',
                              original: professionData
                            };
                          case 'PH':
                            return {
                              profession: professionData.philippines_name,
                              type: professionType?.english_name,
                              countryLabel: 'Philippines',
                              original: professionData
                            };
                          case 'IN':
                          case 'VN':
                          case 'KH':
                          case 'TH':
                          case 'LA':
                            return {
                              profession: professionData.international_name,
                              type: professionType?.english_name,
                              countryLabel: getCountryData(country).name,
                              original: professionData
                            };
                          case 'MY':
                          default:
                            return {
                              profession: professionData.malaysia_name || profession,
                              type: professionType?.english_name,
                              countryLabel: 'Malaysia',
                              original: professionData
                            };
                        }
                      };

                      // Process all professions
                      const professionsList = profileData.professions.map(prof =>
                        getCountrySpecificProfession(prof)
                      );

                      // Get the first profession's type (assuming all have the same type)
                      const professionType = professionsList[0]?.type;
                      const countryLabel = professionsList[0]?.countryLabel;

                      return (
                        <View>
                          {/* Profession Type Header */}
                          {professionType && (
                            <View style={{ marginBottom: 12 }}>
                              <View style={{ flexDirection: "row", alignItems: "center" }}>
                                <FontAwesome5 name="id-badge" size={12} color="rgba(0,0,0,0.5)" />
                                <Text
                                  style={{
                                    fontSize: normalize(12),
                                    color: "rgba(0,0,0,0.6)",
                                    marginLeft: 6,
                                    fontWeight: "500"
                                  }}
                                >
                                  {professionType}
                                </Text>
                              </View>
                            </View>
                          )}

                          {/* Professions as pills */}
                          <View style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            marginBottom: 8,
                            marginHorizontal: -4
                          }}>
                            {professionsList.map((prof, index) => {
                              const { title, subtitle } = extractProfessionTitleAndSubtitle(prof.profession);
                              return (
                                <View
                                  key={index}
                                  style={{
                                    backgroundColor: "#F3F4F6",
                                    borderRadius: 16,
                                    paddingHorizontal: 14,
                                    paddingVertical: subtitle ? 10 : 8,
                                    margin: 4,
                                    borderWidth: 1,
                                    borderColor: "#E5E7EB",
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: normalize(13),
                                      color: "#374151",
                                      fontWeight: "500"
                                    }}
                                  >
                                    {title}
                                  </Text>
                                  {subtitle && (
                                    <Text
                                      style={{
                                        fontSize: normalize(11),
                                        color: "rgba(0,0,0,0.5)",
                                        fontWeight: "400",
                                        marginTop: 2,
                                      }}
                                    >
                                      {subtitle}
                                    </Text>
                                  )}
                                </View>
                              );
                            })}
                          </View>

                          {/* Show international names if any are different */}
                          {professionsList.some(prof =>
                            prof.original.international_name &&
                            prof.original.international_name !== prof.profession
                          ) && (
                              <View style={{ marginTop: 8, marginBottom: 4 }}>
                                <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
                                  <FontAwesome5 name="globe-americas" size={11} color="rgba(0,0,0,0.4)" style={{ marginTop: 2 }} />
                                  <View style={{ marginLeft: 6, flex: 1 }}>
                                    <Text
                                      style={{
                                        fontSize: normalize(11),
                                        color: "rgba(0,0,0,0.5)",
                                        fontStyle: "italic",
                                        lineHeight: 16
                                      }}
                                    >
                                      {professionsList
                                        .filter(prof => prof.original.international_name && prof.original.international_name !== prof.profession)
                                        .map(prof => prof.original.international_name)
                                        .join(' • ')
                                      }
                                    </Text>
                                  </View>
                                </View>
                              </View>
                            )}

                          {/* Country indicator */}
                          <View style={{ flexDirection: "row", alignItems: "center", marginTop: 8 }}>
                            <FontAwesome5 name="map-marker-alt" size={11} color="rgba(0,0,0,0.4)" />
                            <Text
                              style={{
                                fontSize: normalize(11),
                                color: "rgba(0,0,0,0.5)",
                                marginLeft: 6
                              }}
                            >
                              {countryLabel} Classification
                            </Text>
                          </View>
                        </View>
                      );
                    })() : (
                      // Fallback to old single profession field if professions array is not available
                      profileData?.profession ? (() => {
                        const professionData = profileData.profession;
                        const professionType = professionData.profession_type;

                        // Get country-specific profession names
                        const getCountrySpecificProfession = () => {
                          switch (country) {
                            case 'ID':
                              return {
                                profession: professionData.indonesia_name,
                                type: professionType?.malay_name,
                                countryLabel: 'Indonesia'
                              };
                            case 'SG':
                              return {
                                profession: professionData.singapore_name,
                                type: professionType?.english_name,
                                countryLabel: 'Singapore'
                              };
                            case 'PH':
                              return {
                                profession: professionData.philippines_name,
                                type: professionType?.english_name,
                                countryLabel: 'Philippines'
                              };
                            case 'IN':
                            case 'VN':
                            case 'KH':
                            case 'TH':
                            case 'LA':
                              return {
                                profession: professionData.international_name,
                                type: professionType?.english_name,
                                countryLabel: getCountryData(country).name
                              };
                            case 'MY':
                            default:
                              return {
                                profession: professionData.malaysia_name || profession,
                                type: professionType?.english_name,
                                countryLabel: 'Malaysia'
                              };
                          }
                        };

                        const countryProfession = getCountrySpecificProfession();

                        return (
                          <View>
                            <Text
                              style={{
                                fontSize: normalize(14),
                                fontWeight: "600",
                                color: "rgba(0,0,0,0.9)",
                                marginBottom: 6
                              }}
                            >
                              {countryProfession.profession}
                            </Text>

                            {countryProfession.type && (
                              <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 4 }}>
                                <FontAwesome5 name="id-badge" size={12} color="rgba(0,0,0,0.5)" />
                                <Text
                                  style={{
                                    fontSize: normalize(12),
                                    color: "rgba(0,0,0,0.6)",
                                    marginLeft: 6
                                  }}
                                >
                                  Type: {countryProfession.type}
                                </Text>
                              </View>
                            )}

                            {professionData.international_name &&
                              professionData.international_name !== countryProfession.profession && (
                                <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 4 }}>
                                  <FontAwesome5 name="globe-americas" size={12} color="rgba(0,0,0,0.5)" />
                                  <Text
                                    style={{
                                      fontSize: normalize(11),
                                      color: "rgba(0,0,0,0.5)",
                                      marginLeft: 6,
                                      fontStyle: "italic"
                                    }}
                                  >
                                    {professionData.international_name}
                                  </Text>
                                </View>
                              )}

                            <View style={{ flexDirection: "row", alignItems: "center" }}>
                              <FontAwesome5 name="map-marker-alt" size={12} color="rgba(0,0,0,0.5)" />
                              <Text
                                style={{
                                  fontSize: normalize(11),
                                  color: "rgba(0,0,0,0.5)",
                                  marginLeft: 6
                                }}
                              >
                                {countryProfession.countryLabel} Classification
                              </Text>
                            </View>
                          </View>
                        );
                      })() : (
                        <Text style={{ color: "rgba(0,0,0,0.5)" }}>
                          No specialization selected
                        </Text>
                      )
                    )}
                  </View>
                  {fromDoctorCard
                    ? null
                    : editButton(
                      "Edit Profession",
                      "EditProfessionScreen"
                    )}
                </>
              )}
              <View style={{ margin: 10 }} />


              {isDoctor &&
                // !fromDoctorCard &&
                isAssistant(profileData?.expertise) === false ? (
                <>
                  {renderTitle("Medical License", "address-card")}
                  {profileLoading ? (
                    <View style={{ marginTop: 20 }}>
                      <ContentLoader
                        speed={2}
                        width={400}
                        height={150}
                        viewBox="0 0 400 150"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                      >
                        <Circle cx="10" cy="20" r="8" />
                        <Rect
                          x="25"
                          y="15"
                          rx="5"
                          ry="5"
                          width="220"
                          height="10"
                        />
                        <Circle cx="10" cy="50" r="8" />
                        <Rect
                          x="25"
                          y="45"
                          rx="5"
                          ry="5"
                          width="220"
                          height="10"
                        />
                      </ContentLoader>
                    </View>
                  ) : (
                    <>
                      <View style={{ margin: 8 }}>
                        {titleValue(`${getPracticeLicenseName(country)} No.`, profileData?.apc)}
                        {isNurses(profileData?.expertise) || country === "PH" ? null : (
                          <>
                            {titleValue(`${getMedicalLicenseName(country)} No.`, profileData?.mmc)}
                            {profileData?.nsr &&
                              titleValue("NSR No.", profileData?.nsr)}
                          </>
                        )}
                      </View>
                      {fromDoctorCard
                        ? null
                        : editButton(
                          "Edit Medical Licenses",
                          "EditProfileScreen",
                          { isEditLicense: true }
                        )}
                      <View style={{ margin: 10 }} />
                    </>
                  )}
                </>
              ) : null}

              {/* Resume Section */}
              {isDoctor && (
                <>
                  {renderTitle("Resume", "file-alt")}
                  {profileLoading ? (
                    <View style={{ marginTop: 20 }}>
                      <ContentLoader
                        speed={2}
                        width={400}
                        height={100}
                        viewBox="0 0 400 100"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                      >
                        <Circle cx="10" cy="20" r="8" />
                        <Rect
                          x="25"
                          y="15"
                          rx="5"
                          ry="5"
                          width="220"
                          height="10"
                        />
                      </ContentLoader>
                    </View>
                  ) : (
                    <>
                      <View style={{ margin: 8 }}>
                        {profileData?.resume ? (
                          <TouchableOpacity
                            onPress={() => {
                              WebBrowser.openBrowserAsync(profileData?.resume);
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: "#f5f5f5",
                              padding: 12,
                              borderRadius: 8,
                              marginTop: 8,
                            }}
                          >
                            <FontAwesome5 name="file-pdf" size={20} color="#007AFF" />
                            <Text
                              style={{
                                fontSize: normalize(14),
                                marginLeft: 10,
                                color: "#007AFF",
                                fontWeight: "500",
                              }}
                            >
                              View Uploaded Resume
                            </Text>
                          </TouchableOpacity>
                        ) : (
                          <Text style={{ color: "rgba(0,0,0,0.5)", fontSize: normalize(14) }}>
                            No resume uploaded
                          </Text>
                        )}
                      </View>
                      {!fromDoctorCard &&
                        editButton(
                          profileData?.resume ? "Update Resume" : "Upload Resume",
                          "EditProfileScreen",
                          { isUploadResume: true }
                        )}
                    </>
                  )}
                </>
              )}

              {renderTitle("Education", "user-graduate")}
              <View style={{ margin: 10 }} />
              {profileLoading ? (
                <>
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={150}
                    viewBox="0 0 400 150"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                  >
                    <Circle cx="10" cy="20" r="8" />
                    <Rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                    <Circle cx="10" cy="50" r="8" />
                    <Rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                    <Circle cx="10" cy="80" r="8" />
                    <Rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
                  </ContentLoader>
                </>
              ) : (
                <View>
                  {profileData?.education?.map((education) => {
                    return (
                      <View style={{ margin: 10 }}>
                        <Text
                          style={{
                            fontWeight: "bold",
                            color: "rgba(0,0,0,0.9)",
                            marginBottom: 4,
                          }}
                        >
                          {education.name}
                        </Text>
                        <Text
                          style={{
                            color: "rgba(0,0,0,0.6)",
                          }}
                        >
                          {education.year} - {education.school}
                        </Text>
                      </View>
                    );
                  })}
                </View>
              )}
              {fromDoctorCard ? (
                <></>
              ) : (
                editButton("Edit Education", "EditEducationScreen")
              )}
            </>
          ) : (
            <>
              <View
                style={{
                  margin: 10,
                }}
              />
              {renderTitle("Facility Information", "clinic-medical")}
              <View style={{ margin: 10 }} />
              {profileLoading || clinicLoading ? (
                <>
                  <ContentLoader
                    speed={2}
                    width={476}
                    height={124}
                    viewBox="0 0 476 124"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                  >
                    <Rect x="111" y="9" rx="3" ry="3" width="144" height="12" />
                    <Rect x="110" y="73" rx="3" ry="3" width="133" height="6" />
                    <Rect x="111" y="55" rx="3" ry="3" width="62" height="6" />
                    <Circle cx="47" cy="42" r="38" />
                    <Rect x="111" y="39" rx="0" ry="0" width="65" height="7" />
                  </ContentLoader>
                </>
              ) : (
                <Row
                  style={{
                    marginHorizontal: 10,
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <View>
                    {titleValue("Facility Name", clinicData?.name)}
                    {clinicData?.department ? titleValue(
                      "Facility Department", clinicData?.department
                    ) : null}
                    {titleValue(
                      "Facility Type",
                      facilityTypeName
                    )}



                    {titleValue("Facility Address", " ")}

                    <Text style={{ width: "50%", marginTop: -10 }}>
                      {clinicData.address}
                    </Text>
                    <Text>{clinicData.city}</Text>
                    {clinicData.postcode ? (
                      <Text>
                        {clinicData.postcode}, {clinicData.state}
                      </Text>
                    ) : null}

                    {titleValue("Facility Phone No.", clinicData?.phone_number)}
                    {titleValue("Facility Email", profileData?.email)}
                    {titleValue(
                      getBusinessRegistrationLabel(country),
                      clinicData?.business_registration_number
                    )}
                  </View>
                </Row>
              )}
              {fromDoctorCard ? (
                <></>
              ) : (
                editButton("Edit Facility Details", "EditClinicScreen")
              )}
            </>
          )}
          {isDoctor ? null : (
            <>
              {renderTitle("App Manager Information", "user")}
              {profileLoading ? (
                <View style={{ marginTop: 20 }}>
                  <ContentLoader
                    speed={2}
                    width={400}
                    height={150}
                    viewBox="0 0 400 150"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    {...props}
                  >
                    <Circle cx="10" cy="20" r="8" />
                    <Rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                    <Circle cx="10" cy="50" r="8" />
                    <Rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                  </ContentLoader>
                </View>
              ) : (
                <>
                  <View
                    style={{
                      marginLeft: 8,
                      marginTop: 24,
                      alignItems: "flex-start",
                    }}
                  >
                    <Image
                      source={{
                        uri: profileData?.profile_image
                          ? "data:image/jpg;base64," + profileData?.profile_image
                          : PLACEHOLDER_PROFILE_URL,
                      }}
                      style={{ width: 75, height: 75, borderRadius: 50 }}
                    />
                  </View>
                  <View style={{ margin: 8 }}>
                    {titleValue(
                      "App Manager Name",
                      profileData?.first_name
                        ? profileData?.first_name +
                        ` ${profileData?.last_name === "-"
                          ? ""
                          : profileData?.last_name
                        }`
                        : ""
                    )}
                    {titleValue(
                      "App Manager Mobile No.",
                      profileData?.phone_number
                    )}
                    {titleValue(
                      "App Assistant Manager Name",
                      profileData?.emergency_name
                    )}
                    {titleValue(
                      "App Assistant Manager Mobile No.",
                      profileData?.emergency_number
                    )}
                  </View>
                  {editButton("Edit Facility Manager", "EditProfileScreen")}
                  <View style={{ margin: 10 }} />
                </>
              )}
              {/* Facility Specialization Section */}
              {!isDoctor ? (
                <>
                  {renderTitle("Facility Specialization", "hospital")}
                  {profileLoading ? (
                    <View style={{ marginTop: 20 }}>
                      <ContentLoader
                        speed={2}
                        width={400}
                        height={100}
                        viewBox="0 0 400 100"
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        {...props}
                      >
                        <Circle cx="10" cy="20" r="8" />
                        <Rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
                        <Circle cx="10" cy="50" r="8" />
                        <Rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
                      </ContentLoader>
                    </View>
                  ) : (
                    <>
                      <View style={{ margin: 8 }}>
                        {profileData?.role?.clinics?.[0]?.fac_list ? (() => {
                          const facList = profileData.role.clinics[0].fac_list;
                          const facType = facList.fac_type;

                          // Get country-specific names based on user's country
                          const getCountrySpecificName = () => {
                            switch (country) {
                              case 'ID':
                                return {
                                  specialization: facList.name_indonesia,
                                  type: facType?.name_indonesia,
                                  countryLabel: 'Indonesia'
                                };
                              case 'SG':
                                return {
                                  specialization: facList.name_singapore,
                                  type: facType?.name_singapore,
                                  countryLabel: 'Singapore'
                                };
                              case 'PH':
                                return {
                                  specialization: facList.name_philippines,
                                  type: facType?.name_philippines,
                                  countryLabel: 'Philippines'
                                };
                              case 'MY':
                              default:
                                return {
                                  specialization: facList.name_malaysia,
                                  type: facType?.name_malaysia,
                                  // Countries without their own facility names share the Malaysia list
                                  countryLabel: getCountryData(country).name
                                };
                            }
                          };

                          const countryData = getCountrySpecificName();

                          return (
                            <View>
                              {/* Main specialization */}
                              <Text
                                style={{
                                  fontSize: normalize(14),
                                  fontWeight: "600",
                                  color: "rgba(0,0,0,0.9)",
                                  marginBottom: 6
                                }}
                              >
                                {countryData.specialization}
                              </Text>

                              {/* Facility type */}
                              {countryData.type && (
                                <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 4 }}>
                                  <FontAwesome5 name="building" size={12} color="rgba(0,0,0,0.5)" />
                                  <Text
                                    style={{
                                      fontSize: normalize(12),
                                      color: "rgba(0,0,0,0.6)",
                                      marginLeft: 6
                                    }}
                                  >
                                    Type: {countryData.type}
                                  </Text>
                                </View>
                              )}

                              {/* Country indicator */}
                              <View style={{ flexDirection: "row", alignItems: "center" }}>
                                <FontAwesome5 name="globe" size={12} color="rgba(0,0,0,0.5)" />
                                <Text
                                  style={{
                                    fontSize: normalize(11),
                                    color: "rgba(0,0,0,0.5)",
                                    marginLeft: 6
                                  }}
                                >
                                  {countryData.countryLabel} Classification
                                </Text>
                              </View>
                            </View>
                          );
                        })() : (
                          <Text style={{ color: "rgba(0,0,0,0.5)" }}>
                            No facility specialization selected
                          </Text>
                        )}
                      </View>
                      {fromDoctorCard
                        ? null
                        : editButton(
                          "Edit Facility Specialization",
                          "EditFaciltyScreen"
                        )}
                    </>
                  )}
                  <View style={{ margin: 10 }} />
                </>
              ) : null}

            </>
          )}
          <View style={{ margin: 10 }} />

          <View style={{ margin: 100 }} />
          {fromDoctorCard ? (
            <></>
          ) : (
            <View
              style={{
                alignItems: "center",
              }}
            >
              <TouchableOpacity onPress={onPressDelete}>
                <Text
                  style={{
                    color: "red",
                    fontSize: normalize(12),
                    opacity: 0.5,
                  }}
                >
                  Delete Account
                </Text>
              </TouchableOpacity>
            </View>
          )}
        </View>

        <View style={{ margin: 100 }} />
      </ScrollView>
      {/* <Loading visible={profileLoading || userLoading} /> */}

      <BottomModal visible={modalVisible} hide={() => setModalVisible(false)} />
      <Modal
        isVisible={verifiedModalVisible}
        onBackdropPress={() => setVerifiedModalVisible(false)}
        animationIn={"fadeIn"}
        animationOut={"fadeOut"}
      >
        <View
          style={{
            margin: 32,
            marginVertical: 12,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Image
            source={require("../../../assets/images/check.png")}
            style={{ height: 14, width: 14 }}
          />
          <Text
            style={{
              fontWeight: "bold",
              fontSize: normalize(20),
              marginHorizontal: 8,
            }}
          >
            Verified
          </Text>
        </View>

        <Text
          style={{
            marginTop: 4,
            marginBottom: 8,
            marginHorizontal: 32,
          }}
        >
          {`${profileData?.first_name} ${profileData?.last_name[0]}. account has been verified by the Supermedic team\n\n`}
          <Text style={{ fontWeight: "bold" }}>{`Verified documents:\n`}</Text>
          <Text style={{ lineHeight: 24 }}>
            {`- Medical Licenses (${getPracticeLicenseName(country)}, ${getMedicalLicenseName(country)}${profileData?.nsr ? ', NSR' : ''})\n- Clinical Expertise\n- Personal Information`}
          </Text>
        </Text>
        <ModalButtons
          onCancel={() => setVerifiedModalVisible(false)}
          onConfirm={() => setVerifiedModalVisible(false)}
          rightLabel={"OK"}
        />
      </Modal>
      <VerificationModal
        isVisible={verifyModalVisible}
        onHide={() => setVerifyModalVisible(false)}
        onConfirm={() => {
          setVerifyModalVisible(false);
        }}
      />
    </>
  );
}

const styles = {
  title: {
    margin: 18,
  },
  jobsAvailableTitle: {
    fontSize: 24,
    fontFamily: "NotoSans-Bold",
    letterSpacing: -1,
    marginLeft: 18,
    marginBottom: 10,
  },
  filterText: {
    fontWeight: "bold",
  },
  divider: {
    alignSelf: "center",
    width: "90%",
    height: 0.5,
    backgroundColor: "#eee",
    marginBottom: 24,
  },
  sortContainer: {
    marginTop: -18,
    alignItems: "flex-end",
    marginRight: 18,
  },
  sortByText: {
    fontSize: 12,
    marginBottom: 2,
  },
  sortText: {
    fontWeight: "bold",
  },
  line: {
    marginTop: 20,
    width: "100%",
    height: 1,
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  lineTitle: {
    padding: 10,
    backgroundColor: "white",
    marginTop: -18,
  },
  editButton: {
    marginTop: 24,
    borderRadius: 8,
    borderWidth: 1,
    padding: 10,
    paddingHorizontal: 18,
    borderColor: "rgba(0,0,0,0.3)",
  },
  sectionTitle: {
    fontFamily: "NotoSans-Bold",
    fontSize: normalize(18),
    letterSpacing: -0.5,
    marginLeft: 14,
  },
};
